
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class QueryPropertyModel extends Model<QueryPropertyModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'name', type: 'string' },
		{ name: 'type', type: 'QueryPropertyType' },
		{ name: 'options', type: 'Record<string, string>', isArray: true, isDictionary: true },
		{ name: 'nullable', type: 'boolean' },
		{ name: 'customProperty', type: 'CustomPropertyType' }
	];
	[key: string]: any;
	
	public name: string;
	public type: QueryPropertyType;
	public options: Record<string, string>;
	public nullable: boolean;
	public customProperty?: CustomPropertyType;
    
	constructor(){
		super();
		this.name = '';
		this.type = 0;
		this.options = {};
		this.nullable = false;
		this.customProperty = undefined;
		
	}
	getProperties(){
		return QueryPropertyModel.classProperties;
	}
}

export enum QueryPropertyType{
	Text = 0,
	Numeric = 1,
	Date = 2,
	Select = 3,
	Custom = 4,
	ReferenceUsers = 5,
	ReferenceCompany = 6
}
export namespace QueryPropertyType {
	export function getKeys(): Map<QueryPropertyType, string> {
		return new Map([[0, 'Text'], [1, 'Numeric'], [2, 'Date'], [3, 'Select'], [4, 'Custom'], [5, 'ReferenceUsers'], [6, 'ReferenceCompany']]);
	}
}
export enum CustomPropertyType{
	TaskTemplateTag = 0,
	TaskflowTemplateTag = 1,
	AssignedToUserTeam = 2,
	TaskActionOnActiveStep = 3
}
export namespace CustomPropertyType {
	export function getKeys(): Map<CustomPropertyType, string> {
		return new Map([[0, 'TaskTemplateTag'], [1, 'TaskflowTemplateTag'], [2, 'AssignedToUserTeam'], [3, 'TaskActionOnActiveStep']]);
	}
}
